import { render, staticRenderFns } from "./ServiceDurationBoxPlot.vue?vue&type=template&id=2de8efb2"
import script from "./ServiceDurationBoxPlot.vue?vue&type=script&lang=js"
export * from "./ServiceDurationBoxPlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports